/**
 * Statement inquiry Vuex module for Portal Application
 * Controls the data and actions for statements
 * 
 * @module Statements
 * @see
 * @author Alex Smith (Fresche Solutions)
 * @date August 2024
 */

import portalapi from "@services/portalapi";
import { resetStateData } from "@/utils/vuexStoreUtils";
import { getField, updateField } from "vuex-map-fields";

const DEFAULT_STATEMENT = {
    statementFound: null,
    header: {},
    lines: [],
};

const DEFAULT_STATE = {
    statement: DEFAULT_STATEMENT,
    statementList: [],
    statementTypes: [],
};

const state = structuredClone(DEFAULT_STATE);

const getters = {
    getField, // for vuex-map-fields

    getStatement(st) {
        return st.statement;
    },

    getStatementList(st) {
        return st.statementList;
    },

    getStatementTypes(st) {
        return st.statementTypes;
    }
};

const mutations = {
    updateField, // for vuex-map-fields

    async clearStateData(st) {
        st = resetStateData(st, DEFAULT_STATE);
    },
    
    setStatement(st, payload) {
        st.statement = payload;
    },
    
    setStatementList(st, payload) {
        st.statementList = payload;
    },

    setStatementTypes(st, payload) {
        st.statementTypes = payload;
    }
};

const actions = {
    // Get all statements
    async fetchAllStatements({ commit }, payload) 
    {
        const requestPayload = {
            page: (payload && payload.page ? payload.page : 1),
            itemsPerPage: (payload && payload.itemsPerPage ? payload.itemsPerPage : 20),
            filters: (payload && payload.filters ? payload.filters : []),
            sortBy: (payload && payload.sortBy ? payload.sortBy : {column: "toDate", state: "desc"}),
        };

        const response = await portalapi.moduleStatements.getStatementsPage(requestPayload);
        
        if (response && response.status === vm.config.globalProperties.$constants.HTTP_STATUS_CODES.OK) {
            commit("setStatementList", response.data);
        }
    },


    // Get statement header and save into VueX store
    async fetchStatement({ commit }, {statementId, statementType}) 
    {
        commit("setStatement", DEFAULT_STATEMENT);   

        var statement = await actions.retrieveStatement({ commit }, {statementId, statementType});

        commit("setStatement", statement);
    },
    
    
    // Get and return Statement
    async retrieveStatement({ commit }, {statementId, statementType}) 
    {
        let response = await portalapi.moduleStatements.getStatement(statementId, statementType);

        // Check if the statement was found
        if (response && response.status === vm.config.globalProperties.$constants.HTTP_STATUS_CODES.OK) {
            response = response.data
            response.statementFound = true;
        } else {
            response = {
                statementFound: false,
            };
        }

        return response;
    },

    // Get Statement Types
    async fetchStatementTypes(context) 
    {
        var commit = context.commit;

        if (context.state.statementTypes.length == 0) {
            const response = await portalapi.moduleStatements.getStatementTypes();

            if (response.status === vm.config.globalProperties.$constants.HTTP_STATUS_CODES.OK) {
                commit("setStatementTypes", response.data);
            }
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};